import { DashboardContent } from 'src/layouts/dashboard';

import { CustomBreadcrumbs } from '../custom-breadcrumbs';

type PageProps = {
  title: string;
  breadcrumbs: { name: string; href: string }[];
  renderAction?: () => React.ReactNode;
  children: React.ReactNode;
  backHref?: string | number;
  scrollable?: boolean;
};

export function Page({
  title,
  breadcrumbs,
  renderAction,
  children,
  backHref,
  scrollable,
}: PageProps) {
  return (
    <DashboardContent
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflowX: scrollable ? 'auto' : 'hidden',
      }}
    >
      <CustomBreadcrumbs
        backHref={backHref}
        heading={title}
        links={breadcrumbs}
        action={renderAction?.()}
        sx={{ mb: { xs: 3, md: 5 } }}
      />

      {children}
    </DashboardContent>
  );
}
